import { t } from 'i18next';
import { useDialogContext } from '../../DialogContext';
import { Textarea } from '@e2n/ui';

export function InterneNotiz({ interneNotiz }: { interneNotiz: string }) {
  const { dispatch, planwerteForm } = useDialogContext();

  function handleUpdateInterneNotiz(value: string) {
    dispatch({
      type: 'updateInterneNotiz',
      values: {
        interneNotiz: value,
      },
    });
  }

  return (
    <Textarea
      className="focus-visible:ring-0"
      value={planwerteForm.formValues.interneNotiz}
      placeholder={
        !interneNotiz
          ? t(
              'domain.controlling.umsatzplanung.planung.tagesInformation.placeholder',
            )
          : undefined
      }
      onChange={(e) => handleUpdateInterneNotiz(e.currentTarget.value)}
    />
  );
}
